var map = {
	"./3d-calculator-icon.svg": [
		56894,
		14054
	],
	"./3d-calculator-small.svg": [
		10334,
		99692
	],
	"./Level.svg": [
		46484,
		39898
	],
	"./accordion-arrow.svg": [
		31592,
		15962
	],
	"./action-copy.svg": [
		5590,
		94952
	],
	"./action-customize.svg": [
		99406,
		51490
	],
	"./action-edit.svg": [
		22621,
		5347
	],
	"./action-embed.svg": [
		14196,
		2104
	],
	"./action-merge.svg": [
		19387,
		90687
	],
	"./action-print.svg": [
		81550,
		26798
	],
	"./action-share.svg": [
		78662,
		82042
	],
	"./actions.svg": [
		45159,
		60885
	],
	"./active-indicator.svg": [
		47844,
		61168
	],
	"./activity.svg": [
		28441,
		94365
	],
	"./add-icon.svg": [
		67603,
		75811
	],
	"./add-student.svg": [
		82761,
		97395
	],
	"./add.svg": [
		13775,
		33509
	],
	"./alert-circle.svg": [
		42721,
		16465
	],
	"./annotate-arrow.svg": [
		96205,
		38554
	],
	"./annotate-delete.svg": [
		93934,
		17748
	],
	"./annotate-draw.svg": [
		86281,
		40247
	],
	"./annotate-ellipse.svg": [
		84515,
		82235
	],
	"./annotate-eraser.svg": [
		41271,
		99549
	],
	"./annotate-highlight.svg": [
		84413,
		12405
	],
	"./annotate-interact.svg": [
		11029,
		83931
	],
	"./annotate-line.svg": [
		93277,
		75767
	],
	"./annotate-off.svg": [
		92958,
		44350
	],
	"./annotate-rectangle.svg": [
		21042,
		80198
	],
	"./annotate-select.svg": [
		80015,
		49557
	],
	"./annotate-text.svg": [
		22850,
		96568
	],
	"./annotate-triangle.svg": [
		38055,
		91369
	],
	"./archive.svg": [
		12084,
		40706
	],
	"./arrow-circle-up.svg": [
		72064,
		38034
	],
	"./arrow-left.svg": [
		96013,
		63789
	],
	"./arrow-next.svg": [
		2973,
		1613
	],
	"./arrow-popout.svg": [
		28025,
		97233
	],
	"./arrow-prev--blue.svg": [
		22323,
		26307
	],
	"./arrow-prev.svg": [
		46661,
		941
	],
	"./arrow-right.svg": [
		74928,
		82886
	],
	"./arrow-up.svg": [
		71197,
		76741
	],
	"./arrows-up-down.svg": [
		52623,
		5139
	],
	"./assessment.svg": [
		74548,
		68364
	],
	"./assign-circle.svg": [
		30122,
		41176
	],
	"./assign-live-learn.svg": [
		20037,
		30611
	],
	"./assign-now-or-schedule.svg": [
		43466,
		91370
	],
	"./assign-preview.svg": [
		84726,
		1090
	],
	"./assignment-placeholder.svg": [
		35933,
		88045
	],
	"./assignment.svg": [
		40273,
		17297
	],
	"./audio-no-circle.svg": [
		43081,
		24179
	],
	"./audio-placeholder.svg": [
		19692,
		14230
	],
	"./audio.svg": [
		19328,
		26646
	],
	"./authoring/el-logo.svg": [
		80465,
		96509
	],
	"./authoring/guidebooks-logo.svg": [
		2086,
		60342
	],
	"./authoring/im-logo.svg": [
		39982,
		65986
	],
	"./authoring/odell-logo.svg": [
		69046,
		408
	],
	"./award.svg": [
		64977,
		28847
	],
	"./badge-check.svg": [
		93416,
		34046
	],
	"./badge-checkmark.svg": [
		37059,
		79813
	],
	"./block-view.svg": [
		33345,
		76417
	],
	"./blocks.svg": [
		73328,
		46528
	],
	"./bolt-filled.svg": [
		37060,
		94938
	],
	"./bolt.svg": [
		32123,
		49247
	],
	"./bookmark-plus.svg": [
		32643,
		43549
	],
	"./bookmark.svg": [
		53626,
		25974
	],
	"./bookmarked.svg": [
		29837,
		12081
	],
	"./bubble-bottom-left.svg": [
		64930,
		16718
	],
	"./bubble-bottom-right.svg": [
		80281,
		66987
	],
	"./bubble-center.svg": [
		46822,
		71176
	],
	"./bubble-left-bottom.svg": [
		44914,
		10022
	],
	"./bubble-left-top.svg": [
		23720,
		46826
	],
	"./bubble-left.svg": [
		19050,
		97024
	],
	"./bubble-right-bottom.svg": [
		8323,
		69069
	],
	"./bubble-right-top.svg": [
		85607,
		22851
	],
	"./bubble-right.svg": [
		29121,
		67293
	],
	"./bubble-top-center.svg": [
		80000,
		67386
	],
	"./bubble-top-left.svg": [
		19452,
		72242
	],
	"./bubble-top-right.svg": [
		10083,
		46823
	],
	"./calendar-add.svg": [
		69878,
		88450
	],
	"./calendar.svg": [
		18280,
		83708
	],
	"./caption.svg": [
		10304,
		8674
	],
	"./card.svg": [
		25428,
		59708
	],
	"./caret-reverse.svg": [
		5894,
		91784
	],
	"./caret.svg": [
		75875,
		3241
	],
	"./chalkboard.svg": [
		69341,
		69625
	],
	"./chat-alt.svg": [
		88494,
		68270
	],
	"./chat.svg": [
		90808,
		82664
	],
	"./check-circle-outline.svg": [
		8810,
		93118
	],
	"./check-circle.svg": [
		31727,
		53407
	],
	"./check.svg": [
		24130,
		76708
	],
	"./cheveron-left.svg": [
		84394,
		35680
	],
	"./chevron-double-right.svg": [
		81338,
		81986
	],
	"./chevron-down.svg": [
		44952,
		1440
	],
	"./chevron-left.svg": [
		72887,
		15543
	],
	"./chevron-right.svg": [
		80338,
		62000
	],
	"./circle.svg": [
		88618,
		96326
	],
	"./class-linked.svg": [
		52364,
		66700
	],
	"./class.svg": [
		94594,
		82492
	],
	"./clever-square.svg": [
		40769,
		9743
	],
	"./clever.svg": [
		42939,
		79699
	],
	"./clipboard-orange.svg": [
		64871,
		35815
	],
	"./clock.svg": [
		34808,
		2554
	],
	"./close.svg": [
		26590,
		26432
	],
	"./cog-solid.svg": [
		49005,
		44315
	],
	"./cog.svg": [
		56751,
		23937
	],
	"./color-none.svg": [
		95530,
		97422
	],
	"./color.svg": [
		64131,
		58393
	],
	"./comment.svg": [
		21161,
		21175
	],
	"./complete-with-errors.svg": [
		56020,
		72880
	],
	"./complete.svg": [
		19927,
		73019
	],
	"./computer.svg": [
		8649,
		37593
	],
	"./connect.svg": [
		44596,
		77750
	],
	"./connection-lost.svg": [
		38993,
		35139
	],
	"./constructions-icon.svg": [
		10778,
		22590
	],
	"./constructions-small.svg": [
		3834,
		61972
	],
	"./content-gate.svg": [
		52395,
		96035
	],
	"./controls.svg": [
		35560,
		48020
	],
	"./copy-site-linked.svg": [
		85503,
		74883
	],
	"./copy-site-personal.svg": [
		61204,
		17364
	],
	"./copy-site-unlinked.svg": [
		76454,
		82054
	],
	"./copy.svg": [
		69465,
		19701
	],
	"./cross.svg": [
		35602,
		79576
	],
	"./cs-no-circle.svg": [
		43133,
		929
	],
	"./data-representations-icon.svg": [
		71691,
		89233
	],
	"./data-representations-small.svg": [
		36021,
		4829
	],
	"./delete.svg": [
		61819,
		1763
	],
	"./doc-no-circle.svg": [
		94785,
		24511
	],
	"./document-outline.svg": [
		85308,
		92252
	],
	"./document-placeholder.svg": [
		56725,
		74761
	],
	"./document-remove.svg": [
		84194,
		80836
	],
	"./document.svg": [
		55321,
		55237
	],
	"./dots-vertical.svg": [
		361,
		64191
	],
	"./download.svg": [
		27402,
		27158
	],
	"./edit.svg": [
		5910,
		74766
	],
	"./embed-resource.svg": [
		91766,
		454
	],
	"./embed.svg": [
		58249,
		8615
	],
	"./empty-classes.svg": [
		37726,
		86736
	],
	"./equation.svg": [
		24124,
		40016
	],
	"./exclamation-triangle.svg": [
		46666,
		74982
	],
	"./exclamation.svg": [
		81637,
		76399
	],
	"./existing-placeholder.svg": [
		83561,
		79105
	],
	"./existing.svg": [
		12581,
		76717
	],
	"./external.svg": [
		5791,
		68035
	],
	"./eye-off.svg": [
		57777,
		71347
	],
	"./eye.svg": [
		82925,
		32851
	],
	"./facebook.svg": [
		69382,
		95662
	],
	"./fail.svg": [
		15330,
		34922
	],
	"./failed.svg": [
		32706,
		85285
	],
	"./field-reset.svg": [
		73448,
		38510
	],
	"./finish.svg": [
		75979,
		15627
	],
	"./flag.svg": [
		54504,
		77748
	],
	"./font.svg": [
		21685,
		6609
	],
	"./four-function-icon.svg": [
		50395,
		63759
	],
	"./four-function-small.svg": [
		5445,
		81055
	],
	"./frame.svg": [
		93829,
		88063
	],
	"./full.svg": [
		27517,
		93101
	],
	"./fullscreen-contract.svg": [
		44536,
		27366
	],
	"./fullscreen-exit.svg": [
		18430,
		71532
	],
	"./fullscreen-expand.svg": [
		44218,
		73356
	],
	"./geogebraitem-placeholder.svg": [
		90139,
		68683
	],
	"./geogebraitem.svg": [
		91467,
		18699
	],
	"./geometry-icon.svg": [
		71376,
		49861
	],
	"./geometry-small.svg": [
		69868,
		38296
	],
	"./google-drive-round.svg": [
		96487,
		87699
	],
	"./google-drive.svg": [
		87224,
		57568
	],
	"./google-exclamation.svg": [
		12747,
		93728
	],
	"./google-signin.svg": [
		7086,
		58076
	],
	"./graduate-cap.svg": [
		25414,
		90678
	],
	"./graphing-icon.svg": [
		74840,
		75090
	],
	"./graphing-small.svg": [
		69604,
		84024
	],
	"./halign-center.svg": [
		88821,
		70847
	],
	"./halign-left.svg": [
		38685,
		4755
	],
	"./halign-right.svg": [
		49600,
		63012
	],
	"./hamburger-gray.svg": [
		44793,
		45373
	],
	"./hamburger.svg": [
		33931,
		45129
	],
	"./handout.svg": [
		52279,
		58421
	],
	"./heading.svg": [
		7512,
		12146
	],
	"./heart.svg": [
		88366,
		78048
	],
	"./help-circle.svg": [
		24275,
		84630
	],
	"./help.svg": [
		99267,
		63827
	],
	"./html-no-circle.svg": [
		5160,
		92760
	],
	"./html-placeholder.svg": [
		46165,
		48941
	],
	"./html.svg": [
		94521,
		88273
	],
	"./image-no-circle.svg": [
		82392,
		92134
	],
	"./image-placeholder.svg": [
		39845,
		29347
	],
	"./image.svg": [
		84937,
		50067
	],
	"./info.svg": [
		9426,
		9058
	],
	"./instagram.svg": [
		67906,
		24216
	],
	"./integration.svg": [
		22408,
		78986
	],
	"./lesson-plan.svg": [
		46814,
		3060
	],
	"./lesson.svg": [
		25334,
		7582
	],
	"./lessonplan-placeholder.svg": [
		88043,
		70607
	],
	"./lessonplan.svg": [
		38235,
		31047
	],
	"./lessonset.svg": [
		35734,
		59876
	],
	"./link.svg": [
		85786,
		90598
	],
	"./linked-copy.svg": [
		48393,
		76671
	],
	"./list.svg": [
		96654,
		74334
	],
	"./live.svg": [
		60660,
		42700
	],
	"./lms.svg": [
		61194,
		34800
	],
	"./loading-spinner.svg": [
		96130
	],
	"./lock.svg": [
		45739,
		95835
	],
	"./logout.svg": [
		18192,
		46504
	],
	"./lp-no-circle.svg": [
		57939,
		57307
	],
	"./lp-toolbar-calculator.svg": [
		24349,
		78711
	],
	"./lp-toolbar-notes.svg": [
		4900,
		4008
	],
	"./lp-toolbar-save-and-exit.svg": [
		61403,
		88603
	],
	"./lp-toolbar-sidebar.svg": [
		28427,
		85739
	],
	"./lp-toolbar-tools.svg": [
		78186,
		64654
	],
	"./medal.svg": [
		50207,
		96029
	],
	"./minus.svg": [
		4446,
		80076
	],
	"./mobile.svg": [
		92696,
		43604
	],
	"./mobile_page/assignment.svg": [
		32654,
		84724
	],
	"./mobile_page/check.svg": [
		64167,
		21267
	],
	"./mobile_page/download.svg": [
		44157,
		61459
	],
	"./mobile_page/fullscreen-expand.svg": [
		99163,
		875
	],
	"./mobile_page/heart.svg": [
		64947,
		27719
	],
	"./mobile_page/lesson.svg": [
		27589,
		85351
	],
	"./move-grip.svg": [
		57314,
		57024
	],
	"./move.svg": [
		65105,
		28581
	],
	"./needs-grading.svg": [
		19382,
		39156
	],
	"./next.svg": [
		79929,
		79753
	],
	"./no-symbol.svg": [
		32636,
		21182
	],
	"./notebook.svg": [
		58261,
		71105
	],
	"./notes.svg": [
		33601,
		49187
	],
	"./notice.svg": [
		95890,
		6254
	],
	"./notification.svg": [
		16359,
		54751
	],
	"./open-book-icon.svg": [
		21398,
		63298
	],
	"./open-book.svg": [
		56228,
		43550
	],
	"./page-placeholder.svg": [
		80559,
		57095
	],
	"./page.svg": [
		7911,
		98383
	],
	"./pause.svg": [
		6096,
		63978
	],
	"./pencil.svg": [
		89937,
		68309
	],
	"./personal-copy.svg": [
		85832,
		40922
	],
	"./picture.svg": [
		62988,
		52294
	],
	"./pie-chart.svg": [
		66484,
		15649
	],
	"./pizza-slice.svg": [
		77061,
		20035
	],
	"./play.svg": [
		49880,
		3616
	],
	"./plus-circle.svg": [
		29459,
		69885
	],
	"./plus-sm.svg": [
		73223,
		55797
	],
	"./plus.svg": [
		23510,
		5810
	],
	"./powerpoint.svg": [
		40157,
		99289
	],
	"./practice/animals-bison.svg": [
		72769,
		5991
	],
	"./practice/animals-cat.svg": [
		74676,
		48774
	],
	"./practice/animals-dog.svg": [
		18678,
		97292
	],
	"./practice/animals-dolphin.svg": [
		49092,
		73930
	],
	"./practice/animals-elephant.svg": [
		39636,
		29843
	],
	"./practice/animals-fish.svg": [
		51318,
		15050
	],
	"./practice/animals-flamingo.svg": [
		15931,
		93455
	],
	"./practice/animals-giraffe.svg": [
		7804,
		79898
	],
	"./practice/animals-lion.svg": [
		10574,
		25918
	],
	"./practice/animals-lizard.svg": [
		90588,
		94944
	],
	"./practice/animals-monkey.svg": [
		94963,
		63383
	],
	"./practice/animals-octopus.svg": [
		29931,
		44037
	],
	"./practice/animals-panda.svg": [
		11800,
		48162
	],
	"./practice/animals-parrot.svg": [
		96112,
		97360
	],
	"./practice/animals-peacock.svg": [
		90910,
		19440
	],
	"./practice/animals-pig.svg": [
		32820,
		80726
	],
	"./practice/animals-sheep.svg": [
		31005,
		93383
	],
	"./practice/animals-tiger.svg": [
		31421,
		49791
	],
	"./practice/animals-turtle.svg": [
		76014,
		1850
	],
	"./practice/animals-whale.svg": [
		35431,
		79409
	],
	"./practice/animals_kangaroo.svg": [
		40260,
		52624
	],
	"./practice/astronomy-asteroid.svg": [
		70896,
		98764
	],
	"./practice/astronomy-astronaut.svg": [
		77036,
		16194
	],
	"./practice/astronomy-blackhole.svg": [
		85890,
		31376
	],
	"./practice/astronomy-comet.svg": [
		92829,
		27923
	],
	"./practice/astronomy-constellation.svg": [
		67640,
		17110
	],
	"./practice/astronomy-earth.svg": [
		92453,
		20079
	],
	"./practice/astronomy-galaxy.svg": [
		76235,
		19175
	],
	"./practice/astronomy-gemini.svg": [
		61130,
		40022
	],
	"./practice/astronomy-lander.svg": [
		54793,
		79897
	],
	"./practice/astronomy-mars.svg": [
		41992,
		20320
	],
	"./practice/astronomy-monkey.svg": [
		40648,
		64132
	],
	"./practice/astronomy-moon.svg": [
		82688,
		95484
	],
	"./practice/astronomy-radar.svg": [
		87385,
		43683
	],
	"./practice/astronomy-rover.svg": [
		32653,
		42051
	],
	"./practice/astronomy-satellite-dish.svg": [
		52631,
		69251
	],
	"./practice/astronomy-satellite.svg": [
		38534,
		23752
	],
	"./practice/astronomy-saturn.svg": [
		41906,
		73690
	],
	"./practice/astronomy-shuttle.svg": [
		11682,
		14500
	],
	"./practice/astronomy-station.svg": [
		89201,
		16615
	],
	"./practice/astronomy-sun.svg": [
		55995,
		52709
	],
	"./practice/astronomy-telescope.svg": [
		19633,
		30996
	],
	"./practice/instruments-accordian.svg": [
		51221,
		80655
	],
	"./practice/instruments-bagpipe.svg": [
		37239,
		83873
	],
	"./practice/instruments-banjo.svg": [
		29019,
		83561
	],
	"./practice/instruments-bongos.svg": [
		6245,
		93045
	],
	"./practice/instruments-clarinet.svg": [
		27449,
		6805
	],
	"./practice/instruments-drums.svg": [
		91910,
		72972
	],
	"./practice/instruments-erhu.svg": [
		9959,
		64463
	],
	"./practice/instruments-flute.svg": [
		22939,
		86397
	],
	"./practice/instruments-gong.svg": [
		68280,
		78596
	],
	"./practice/instruments-harp.svg": [
		97475,
		77156
	],
	"./practice/instruments-kalimba.svg": [
		34268,
		26082
	],
	"./practice/instruments-marimba.svg": [
		3368,
		7238
	],
	"./practice/instruments-pan-flute.svg": [
		91405,
		63303
	],
	"./practice/instruments-piano.svg": [
		18858,
		79040
	],
	"./practice/instruments-saxophone.svg": [
		23744,
		87370
	],
	"./practice/instruments-shekere.svg": [
		15124,
		86774
	],
	"./practice/instruments-tambourine.svg": [
		52699,
		59427
	],
	"./practice/instruments-trombone.svg": [
		899,
		68647
	],
	"./practice/instruments-udu.svg": [
		99289,
		80315
	],
	"./practice/instruments-veena.svg": [
		48894,
		90308
	],
	"./practice/instruments-violin.svg": [
		68384,
		52888
	],
	"./practice/landmarks-bandiagara-cliff-dwellings.svg": [
		54041,
		79269
	],
	"./practice/landmarks-baobabs.svg": [
		87460,
		70774
	],
	"./practice/landmarks-colosseum.svg": [
		52410,
		82624
	],
	"./practice/landmarks-eiffel-tower.svg": [
		93841,
		95249
	],
	"./practice/landmarks-golden-gate-bridge.svg": [
		85237,
		74521
	],
	"./practice/landmarks-grand-canyon.svg": [
		69363,
		93843
	],
	"./practice/landmarks-great-barrier-reef.svg": [
		10640,
		27320
	],
	"./practice/landmarks-great-wall.svg": [
		50436,
		32028
	],
	"./practice/landmarks-halong-bay.svg": [
		164,
		54772
	],
	"./practice/landmarks-icefjord.svg": [
		84814,
		59798
	],
	"./practice/landmarks-iguazu-falls.svg": [
		87452,
		43876
	],
	"./practice/landmarks-kremlin.svg": [
		21282,
		57664
	],
	"./practice/landmarks-kyoto.svg": [
		65500,
		29470
	],
	"./practice/landmarks-machu-picchu.svg": [
		74535,
		43127
	],
	"./practice/landmarks-mt-kilimanjaro.svg": [
		96997,
		95309
	],
	"./practice/landmarks-pyramids.svg": [
		32159,
		18063
	],
	"./practice/landmarks-statue-of-liberty.svg": [
		7252,
		28602
	],
	"./practice/landmarks-taj-mahal.svg": [
		87039,
		53121
	],
	"./practice/landmarks-tikal.svg": [
		96627,
		76789
	],
	"./practice/landmarks-us-capitol.svg": [
		1229,
		17321
	],
	"./practice/landmarks-yellowstone.svg": [
		25295,
		54305
	],
	"./practice/users.svg": [
		18380,
		18402
	],
	"./present.svg": [
		72531,
		13981
	],
	"./previous.svg": [
		84921,
		63401
	],
	"./print.svg": [
		28955,
		89801
	],
	"./probability-icon.svg": [
		12231,
		56059
	],
	"./probability-small.svg": [
		29441,
		20635
	],
	"./puzzle.svg": [
		63622,
		99658
	],
	"./question-mark.svg": [
		28628,
		84950
	],
	"./question-placeholder.svg": [
		21085,
		2138
	],
	"./question.svg": [
		78386,
		3426
	],
	"./rectangle-stack.svg": [
		9298,
		43664
	],
	"./rectangle.svg": [
		14013,
		5735
	],
	"./reference.svg": [
		90897,
		19923
	],
	"./reference_writing.svg": [
		30228,
		86946
	],
	"./refresh.svg": [
		99143,
		72517
	],
	"./reorder.svg": [
		25847,
		99817
	],
	"./reply.svg": [
		89878,
		48228
	],
	"./report.svg": [
		94692,
		86696
	],
	"./reports-empty.svg": [
		99587,
		44749
	],
	"./rescue.svg": [
		47097,
		79069
	],
	"./rewind.svg": [
		57831,
		38599
	],
	"./ribbon-yellow.svg": [
		96739,
		31613
	],
	"./ribbon.svg": [
		134,
		81350
	],
	"./schedule.svg": [
		6257,
		93181
	],
	"./school.svg": [
		42686,
		26022
	],
	"./scientific-icon.svg": [
		84649,
		28327
	],
	"./scientific-small.svg": [
		52327,
		58535
	],
	"./scoring-cross.svg": [
		14186,
		89148
	],
	"./scoring-dash.svg": [
		26050,
		60510
	],
	"./scoring-needs-grading.svg": [
		7454,
		4760
	],
	"./scoring-tick.svg": [
		60681,
		91825
	],
	"./search-circle.svg": [
		98063,
		68801
	],
	"./search-gray.svg": [
		79370,
		19264
	],
	"./search.svg": [
		76002,
		3686
	],
	"./section.svg": [
		40323,
		19453
	],
	"./shape-circle.svg": [
		3102,
		96530
	],
	"./shape-square.svg": [
		84531,
		86011
	],
	"./shape-triangle.svg": [
		2718,
		10454
	],
	"./share.svg": [
		55655,
		54169
	],
	"./side-by-side.svg": [
		95137,
		78565
	],
	"./sis-class.svg": [
		44326,
		5912
	],
	"./slide-placeholder.svg": [
		5877,
		27799
	],
	"./slide.svg": [
		97625,
		47423
	],
	"./smile.svg": [
		58094,
		49004
	],
	"./smiley-help.svg": [
		82533,
		70411
	],
	"./smiley-thinking.svg": [
		5796,
		45394
	],
	"./smiley.svg": [
		27467,
		37499
	],
	"./sort-alpha-asc.svg": [
		76713,
		21497
	],
	"./sortable.svg": [
		4326,
		60206
	],
	"./source-url.svg": [
		75577,
		24553
	],
	"./sparkles.svg": [
		52451,
		80043
	],
	"./speed-fast.svg": [
		43190,
		29246
	],
	"./speed-medium.svg": [
		10097,
		68665
	],
	"./speed-slow.svg": [
		38051,
		42391
	],
	"./spreadsheet-icon.svg": [
		61026,
		7434
	],
	"./spreadsheet-small.svg": [
		3698,
		95232
	],
	"./spreadsheet.svg": [
		22704,
		95766
	],
	"./square.svg": [
		89999,
		46751
	],
	"./standards-coverage-table.svg": [
		61436,
		18968
	],
	"./standards-table.svg": [
		26815,
		24537
	],
	"./star.svg": [
		32466,
		98990
	],
	"./status-online.svg": [
		96408,
		99194
	],
	"./stop.svg": [
		60394,
		32834
	],
	"./student-linked.svg": [
		66971,
		3779
	],
	"./student-tools-placeholder.svg": [
		54325,
		15764
	],
	"./success.svg": [
		90219,
		73649
	],
	"./swatch.svg": [
		46069,
		75910
	],
	"./synced-arrows.svg": [
		63131,
		60277
	],
	"./synced.svg": [
		35724,
		69736
	],
	"./table.svg": [
		58134,
		24028
	],
	"./tall-move-grip.svg": [
		18500,
		94388
	],
	"./template.svg": [
		43800,
		11496
	],
	"./text.svg": [
		83791,
		87415
	],
	"./think_sphere.svg": [
		19030,
		4814
	],
	"./thought.svg": [
		40773,
		65451
	],
	"./toolbox.svg": [
		93907,
		75801
	],
	"./trending-arrow.svg": [
		39033,
		36413
	],
	"./trophy.svg": [
		22144,
		97148
	],
	"./twitter.svg": [
		85171,
		90741
	],
	"./type.svg": [
		19474,
		1386
	],
	"./un-archive.svg": [
		20242,
		30706
	],
	"./unavailable-object.svg": [
		49420,
		93368
	],
	"./unavailable-placeholder.svg": [
		54836,
		39526
	],
	"./unlinked-copy.svg": [
		70050,
		41428
	],
	"./upload.svg": [
		81753,
		12365
	],
	"./url-no-circle.svg": [
		81524,
		39434
	],
	"./url-placeholder.svg": [
		33033,
		20191
	],
	"./url.svg": [
		21733,
		28279
	],
	"./user-group-fill.svg": [
		16873,
		96723
	],
	"./user-group.svg": [
		57277,
		77765
	],
	"./user-solo.svg": [
		9009,
		76667
	],
	"./user.svg": [
		76947,
		67659
	],
	"./users.svg": [
		76154,
		89488
	],
	"./valign-bottom.svg": [
		30001,
		75627
	],
	"./valign-center.svg": [
		70307,
		63581
	],
	"./valign-top.svg": [
		4521,
		44069
	],
	"./video-no-circle.svg": [
		44418,
		36404
	],
	"./video-placeholder.svg": [
		75015,
		36977
	],
	"./video.svg": [
		80367,
		54013
	],
	"./view-grid.svg": [
		70853,
		48064
	],
	"./volume-up.svg": [
		58486,
		43192
	],
	"./volume.svg": [
		52664,
		94988
	],
	"./wikipage-no-circle.svg": [
		73782,
		75502
	],
	"./wikipage.svg": [
		18355,
		47611
	],
	"./wind.svg": [
		36284,
		65028
	],
	"./wrench.svg": [
		16789,
		99877
	],
	"./x--small.svg": [
		79789,
		17345
	],
	"./x-circle.svg": [
		22739,
		49887
	],
	"./youtube.svg": [
		45561,
		76631
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 79697;
module.exports = webpackAsyncContext;